import React from 'react';
import './PremiumLogo.css';

const PremiumLogo = ({ className = '', size = 200, ariaLabel = 'Logo de Flotte' }) => {
  const containerClass = ['premium-logo-container', className].filter(Boolean).join(' ');
  const resolvedSize = typeof size === 'number' ? `${size}px` : size;

  return (
    <div
      className={containerClass}
      style={{ width: resolvedSize, height: resolvedSize, perspective: '1200px' }}
      role="img"
      aria-label={ariaLabel}
    >
      <svg
        viewBox="0 0 1000 1000"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="premium-logo__svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="gradUp" x1="81" y1="164" x2="910" y2="164" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#0178E2" />
            <stop offset="0.5" stopColor="#3B9EFF" />
            <stop offset="1" stopColor="#006CD1" />
          </linearGradient>
          <linearGradient id="gradMid" x1="77" y1="454" x2="627" y2="454" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#007EDF" />
            <stop offset="0.5" stopColor="#40A8FF" />
            <stop offset="1" stopColor="#0069D3" />
          </linearGradient>
          <linearGradient id="gradStem" x1="169" y1="386" x2="169" y2="937" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#02449D" />
            <stop offset="0.4" stopColor="#0060D6" />
            <stop offset="1" stopColor="#012A6B" />
          </linearGradient>
        </defs>
        <g>
          <path
            d="M91.73,944.4l159.14-172.07c5.44-5.89,8.51-13.79,8.57-22.04l1.37-221.23c0.02-3.07-1.22-6-3.39-8.02L90.83,365.74c-5.15-4.81-13.24-0.91-13.23,6.37l0.48,566.37C78.07,946.05,86.73,949.8,91.73,944.4z"
            fill="url(#gradStem)"
          />
          <path
            d="M79.41,377.01l168.21,165.26c1.85,1.82,4.34,2.85,6.93,2.86l207.67,1.23c8.69,0.05,16.97-3.68,22.7-10.22l140.4-160.4c4.53-5.18,0.85-13.28-6.02-13.27L84.99,363.3C77.84,363.31,74.31,372,79.41,377.01z"
            fill="url(#gradMid)"
          />
          <path
            d="M78.24,77.3l-0.92,167.73c-0.03,5.51,4.42,10.01,9.94,10.04l639.85,3.52c6.16,0.03,12.25-1.72,17.24-5.33c1.45-1.05,2.84-2.27,4.04-3.67c0.48-0.56,0.95-1.13,1.46-1.67l155.7-163.89c4.82-5.08,1.24-13.46-5.77-13.48l-811.5-3.17C82.76,67.35,78.27,71.79,78.24,77.3z"
            fill="url(#gradUp)"
          />
        </g>
      </svg>
    </div>
  );
};

export default PremiumLogo;
